import { useMutation } from '@tanstack/react-query'
import Cookies from 'js-cookie'

import { useAppSelector } from '~/store'

type StockRecord = {
    id?: number
    location: {
        id: number
    }
    stock_item: {
        id: number
        sku?: string
    }
    quantity: number
}

export async function updateStockRecords(
    url: string,
    records: StockRecord[]
): Promise<{ count: number }> {
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'X-CSRFToken': Cookies.get('csrftoken') ?? '',
        },
        body: JSON.stringify(records),
    })

    if (!res.ok) {
        throw new Error('Failed to update stock records')
    }

    return await res.json()
}

export function useUpdateStockRecordsMutation() {
    const updateStockRecordsAPIURL = useAppSelector(
        (state) => state.initial.endpoints.updateStockRecordsAPIURL
    )

    return useMutation({
        mutationFn: async (records: StockRecord[]) => {
            return await updateStockRecords(updateStockRecordsAPIURL, records)
        },
    })
}
